export default __webpack_public_path__ + "3c02f28651179aec2570134aa4789c9b.png";